import { render, staticRenderFns } from "./FileShared.vue?vue&type=template&id=77e6c34d&"
import script from "./FileShared.vue?vue&type=script&lang=js&"
export * from "./FileShared.vue?vue&type=script&lang=js&"
import style0 from "./FileShared.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports